import "../App.css";
import gsap from "gsap";
import { collection, query, where, getDocs } from "firebase/firestore";
import React, { useState, useRef, useEffect } from "react";
import db from "../firebase";
import Detail from "./Detail";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Happy from "./Happy";
import { useMediaQuery } from "react-responsive";

const Header = () => {
  const movieRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({ repeat: 0, repeatDelay: 1 });
    tl.fromTo(
      movieRef.current.querySelectorAll(".movie"),
      { opacity: 0, x: 100 },
      { opacity: 1, x: 0, stagger: 0.1 }
    );
  }, []);
  const navigate = useNavigate(); // この行を追加
  const handleHomeClick = () => {
    navigate("/"); // '/home'パスに遷移
  };

  const [searchParams, setSearchParams] = useState({
    base: "",
    taste: "",
    alcoholContent: "",
    carbonation: "",
  });
  const [searchResults, setSearchResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [selectedCocktail, setSelectedCocktail] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchParams((prevParams) => ({
      ...prevParams,
      [name]: value,
    }));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    navigate("/happy", {
      state: {
        base: searchParams.base,
        taste: searchParams.taste,
        carbonation: searchParams.carbonation,
        alcoholContent: searchParams.alcoholContent,
      },
    });
    formclick();
  };

  const baseOptions = [
    "ウォッカ",
    "テキーラ",
    "ジン",
    "ラム",
    "日本酒",
    "焼酎",
    "ウイスキー",
  ];
  const alcoholContentOptions = ["低", "中", "高", "無"];
  const carbonationOptions = ["有", "無"];
  const tasteOptions = [
    "甘口",
    "中口",
    "辛口",
    "爽やか",
    "さっぱり",
    "フルーティー",
  ];
  const [condition, setcondition] = useState(false);
  const formclick = () => {
    setcondition(!condition);
  };
  // const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <div>
      <header>
        <div className="header-wrapper">
          <div className="header-title">
            <div onClick={handleHomeClick} className="header-logo">
              <div className="movie-block" ref={movieRef}>
                <div className="movie num1"></div>
                <div className="movie num2">E</div>
                <div className="movie num3">z</div>
                <div className="movie num4">y</div>
                <div className="movie num5">D</div>
                <div className="movie num6">r</div>
                <div className="movie num7">i</div>
                <div className="movie num8">n</div>
                <div className="movie num9">k</div>
                <div className="movie num10">i</div>
                <div className="movie num11">n</div>
                <div className="movie num12">g</div>
              </div>
            </div>
          </div>
          <div className="formsearch">
            {condition ? (
              <button onClick={formclick} className="formSelector">
                <span>閉じる</span>
                <img src="./虫眼鏡の無料アイコン10 (1).png" />
              </button>
            ) : (
              <button onClick={formclick} className="formSelector">
                <span>詳しく調べる</span>
                <img src="./虫眼鏡の無料アイコン10 (1).png" />
              </button>
            )}
            <div className="headerSarch">
              {condition ? (
                <form className="former" onSubmit={handleSearch}>
                  <select
                    name="taste"
                    value={searchParams.taste}
                    onChange={handleChange}
                  >
                    <option value="">味を選択</option>
                    {tasteOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>

                  <select
                    name="base"
                    value={searchParams.base}
                    onChange={handleChange}
                  >
                    <option value="">ベースのお酒を選択</option>
                    {baseOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>

                  <select
                    name="alcoholContent"
                    value={searchParams.alcoholContent}
                    onChange={handleChange}
                  >
                    <option value="">アルコール度数を選択</option>
                    {alcoholContentOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>

                  <select
                    name="carbonation"
                    value={searchParams.carbonation}
                    onChange={handleChange}
                  >
                    <option value="">炭酸の有無を選択</option>
                    {carbonationOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>

                  <div class="button-">
                    <button type="submit">検索</button>
                  </div>
                </form>
              ) : null}
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
